
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/all/[childSlug]",
      function () {
        return require("private-next-pages/shop/all/[childSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/all/[childSlug]"])
      });
    }
  